// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter___1_NI","button":"Counter_button__hpevP","value":"Counter_value__igoRg"};